import { UserAchievement } from '../Types/UserAchievement';
import { getApiInstance } from './Api';

export function mapUserAchievement(
  userAchievementViewModel: any,
): UserAchievement {
  return {
    ...userAchievementViewModel,
    createdAt:
      userAchievementViewModel.createdAt &&
      new Date(userAchievementViewModel.createdAt),
    updatedAt:
      userAchievementViewModel.updatedAt &&
      new Date(userAchievementViewModel.updatedAt),
  };
}

export class AchievementsApi {
  async getUserAchievements(): Promise<UserAchievement[]> {
    const response = await getApiInstance().get(`/achievements/user`);
    return response.data.map(mapUserAchievement);
  }

  async getUserAchievement(
    userAchievementId: string,
  ): Promise<UserAchievement> {
    const response = await getApiInstance().get(
      `/achievements/user/${userAchievementId}`,
    );
    return mapUserAchievement(response.data);
  }

  async getUserUntouchedAchievements(): Promise<UserAchievement[]> {
    const response = await getApiInstance().get('/achievements/user-untouched');
    return response.data.map(mapUserAchievement);
  }
}
